import { render, staticRenderFns } from "./s03-finance.vue?vue&type=template&id=4f527a6e&scoped=true"
import script from "./s03-finance.vue?vue&type=script&lang=js"
export * from "./s03-finance.vue?vue&type=script&lang=js"
import style0 from "./s03-finance.vue?vue&type=style&index=0&id=4f527a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f527a6e",
  null
  
)

export default component.exports